import React, { useState, useEffect } from 'react'
import { api } from '../../utils/api'

function Putaway() {
  const [items, setItems] = useState([])
  const [locations, setLocations] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadData()
  }, [])

  async function loadData() {
    setLoading(true)
    try {
      const [itemsRes, locationsRes] = await Promise.all([
        api.get('/api/warehouse/putaway'),
        api.get('/api/warehouse/locations')
      ])
      setItems(itemsRes.items || [])
      setLocations(locationsRes.locations || [])
    } catch (error) {
      console.error('Failed to load putaway data:', error)
    } finally {
      setLoading(false)
    }
  }

  async function handleAssignLocation(itemId, locationId) {
    try {
      await api.post(`/api/warehouse/putaway/${itemId}/assign-location`, { location_id: locationId })
      loadData()
    } catch (error) {
      console.error('Failed to assign location:', error)
    }
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--space-12)' }}>
        <div className="loading-spinner" />
      </div>
    )
  }

  if (items.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-title">No Items to Put Away</div>
        <div className="empty-state-description">
          All tested items have been assigned locations.
        </div>
      </div>
    )
  }

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="card-title">Items for Putaway</h2>
        <span className="badge badge-info">{items.length} items</span>
      </div>

      <table className="table">
        <thead>
          <tr>
            <th>Item</th>
            <th>Brand</th>
            <th>Product Type</th>
            <th>Assign Location</th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => (
            <tr key={item.id}>
              <td style={{ fontWeight: 500 }}>{item.name}</td>
              <td>{item.brand || '-'}</td>
              <td>{item.product_type || '-'}</td>
              <td>
                <select
                  className="form-input"
                  style={{ width: 'auto' }}
                  onChange={e => e.target.value && handleAssignLocation(item.id, e.target.value)}
                  defaultValue=""
                >
                  <option value="">Select location...</option>
                  {locations.map(loc => (
                    <option key={loc.id} value={loc.id}>{loc.code} - {loc.description || loc.type}</option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Putaway
